export default __webpack_public_path__ + "static/media/h_icon3.31acd1eb.png";